import { APP_IMG } from 'src/constants';
import styled from 'styled-components';

const FooterBCGTalk = () => {
  const dataNav = [
    { id: 1, name: 'HOME', link: '#HOME' },
    { id: 2, name: 'AGENDA', link: '#AGENDA' },
    { id: 3, name: 'SPEAKERS', link: '#SPEAKERS' },
    { id: 4, name: 'SESSIONS', link: '#SESSIONS' },
    { id: 5, name: 'ABOUT US', link: '#ABOUT_US' }
  ];
  return (
    <FooterWrapper id='ABOUT_US'>
      <div className='footer'>
        <div className='image-center'>
          <a href='/'>
            <img
              src={`${APP_IMG}/logo-white.svg`}
              alt='logo-header'
              width={200}
              height='100%'
            />
          </a>
        </div>
        <ul>
          {dataNav.map((item, index) => (
            <li key={index}>
              <a href={item.link}>
                <p>{item.name}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </FooterWrapper>
  );
};

export default FooterBCGTalk;

const FooterWrapper = styled.footer`
  padding: 60px 0;
  background-color: #ff6633;
  background-repeat: repeat;
  .footer {
    width: 1200px;
    max-width: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
    .image-center {
      text-align: center;
      width: 90%;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (max-width: 690px) {
        padding: 30px 0;
      }
    }
    ul {
      width: 10%;
      list-style-type: none;
      @media (max-width: 768px) {
        width: 100%;
      }
      li {
        @media (max-width: 768px) {
          text-align: center;
        }
        a {
          p {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            padding: 5px 0;
          }
        }
      }
    }
  }
`;
